module.exports = __webpack_public_path__ + "static/media/Level3End.857c85fd.mp4";